import format from 'date-fns/format';
import toDate from 'date-fns/toDate';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService, InstitutionService, AuthService } from '../../shared/services';

@Component({
  selector: 'institution-list',
  templateUrl: './institution-list.component.html',
  styleUrls: [ './institution-list.component.scss' ]
})
export class InstitutionListComponent{

  private appId: string;
  public message: string;

  institutionTable = [];

  loading = true;
  searchValue: string;

  onSearch(data){
    this.searchValue = data.detail && data.detail.length > 0 ? data.detail : null;
  }

  goToSummary(institution){
    this.router.navigate( [ `/${institution.uuid}/${this.appId}/summary`] );
  }

  d(query){
    let f = 'yyyy-MM-dd';
    return  { startdate: format(new Date(query.startdate), f), enddate: format(new Date(query.enddate), f) }
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private auth: AuthService,
    private app: AppService,
    private institution: InstitutionService
  ) {
    this.route.params.subscribe(data => {
      this.auth.get().subscribe( result => {
        this.auth.allowed();
        this.loading = true;
        this.setup(data.appId);
      });
    })
  }

  paginateConfig = {
    itemsPerPage: 20,
    currentPage: 1,
    totalItems: null
  };

  selected(i){
    this.paginateConfig.currentPage = i;
  }

  getMessage(type){
    let types = {
      'no-result': 'No institution found',
      'service-error': 'There was an error requesting data'
    };
    this.message = `${types[type]} for ${this.appId}.`;
  }

  private setup(appId){
    this.appId = appId;
    this.institution.getAll().then( data =>{
      this.loading = false;
      this.institutionTable = data;
      if(!data.length){
        this.getMessage('no-result');
      }
    }, (err) => {
      console.log(err);
      this.loading = false;
      this.institutionTable = [];
      this.getMessage('service-error');
    })
  }

}

